module.exports = __webpack_public_path__ + "static/img/360_3.72b0f76f.png";